import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import { LOAN_CATEGORIES } from "../data/site";

const LOANS = LOAN_CATEGORIES.filter((c) => c.slug !== "credit-card");

const DetailList = ({ title, items }) => (
  <div>
    <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">{title}</h4>
    <ul className="mt-3 space-y-2">
      {items.map((it) => (
        <li key={it} className="flex items-start gap-2 text-sm text-zinc-600">
          <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#6C2BD9]" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  </div>
);

export default function Loans() {
  return (
    <>
      <Seo
        title="Loan Solutions | Personal, Business, Home & Property Loans – CARDED"
        description="Explore CARDED loan solutions: Personal Loan, Business Loan, Home Loan, Loan Against Property and Working Capital. See features, benefits, eligibility & documents, then apply."
      />
      <PageBanner
        overline="Loan Solutions"
        title="Loan Solutions"
        subtitle="From personal milestones to business ambitions — compare tailored options across leading Banks and NBFCs, guided by a team that has your back."
      />

      <section className="bg-white pb-24 sm:pb-32" data-testid="loans-list">
        <div className="mx-auto max-w-7xl space-y-8 px-6 sm:px-10">
          {LOANS.map((loan, i) => (
            <Reveal key={loan.slug} delay={0.04}>
              <article
                className="grid grid-cols-1 gap-8 overflow-hidden rounded-3xl border border-[#E4E4E7] bg-white lg:grid-cols-12"
                data-testid={`loan-detail-${loan.slug}`}
              >
                <div className={`relative min-h-[240px] overflow-hidden lg:col-span-4 ${i % 2 ? "lg:order-last" : ""}`}>
                  <img
                    src={loan.image}
                    alt={`${loan.title} – CARDED loan assistance`}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#6C2BD9]/40 to-transparent" />
                  <div className="absolute left-6 top-6 flex h-12 w-12 items-center justify-center rounded-xl bg-white/90 text-[#6C2BD9] backdrop-blur">
                    <loan.icon className="h-6 w-6" />
                  </div>
                </div>

                <div className="p-8 sm:p-10 lg:col-span-8">
                  <h2 className="text-3xl font-semibold tracking-tight text-[#09090B]">{loan.title}</h2>
                  <p className="mt-3 text-base leading-relaxed text-zinc-600">{loan.description}</p>

                  <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-2">
                    <DetailList title="Features" items={loan.features} />
                    <DetailList title="Benefits" items={loan.benefits} />
                    <DetailList title="Eligibility" items={loan.eligibility} />
                    <DetailList title="Required Documents" items={loan.documents} />
                  </div>

                  <Link
                    to="/contact"
                    className="mt-9 inline-flex items-center gap-2 rounded-full brand-gradient px-8 py-3.5 font-medium text-white transition-transform hover:scale-105 hover:shadow-[0_8px_24px_rgba(108,43,217,0.3)]"
                    data-testid={`loan-apply-${loan.slug}`}
                  >
                    Apply for {loan.title} <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
